// extracted by mini-css-extract-plugin
export var cardIcon = "_56-4";
export var checkboxCard = "_56-0";
export var checkboxCardSelected = "_56-3";
export var disabled = "_56-1";
export var outerBorder = "_56-2";
export var spacerMedium = "_56-7";
export var spacerSmall = "_56-6";
export var spacerXsmall = "_56-5";